import Container from "components/Container";
import { useMainContext } from "context";
import React, { useState } from "react";

import Logo from "./Logo";
import NavBar from "./NavBar";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isLoggedIn, user } = useMainContext();

  const openHandler = () => setIsOpen((prev) => !prev);

  return (
    <header className="bg-white shadow sticky top-0 z-50 w-full">
      <Container>
        <div className="flex flex-col lg:flex-row lg:items-center justify-between py-2">
          {/* Logo, Locales and Hamburger Button Container */}
          <div className="flex items-center justify-between w-full lg:w-auto">
            <Logo isOpen={openHandler} open={isOpen} />
          </div>

          {/* Navigation Menu */}
          <NavBar
            setIsOpen={openHandler}
            open={isOpen}
            isLoggedIn={isLoggedIn}
            user={user}
          />
        </div>
      </Container>
    </header>
  );
};

export default Header;
